import {isRelativeUrl, toRelativeUrl} from "@khan/urls";

import {addCacheParam} from "./add-cache-param.ts";
import {addConfigParams} from "./add-config-params.ts";
import {getXsrfKeyHeaders} from "./get-xsrf-key-headers.ts";
import {isAPIURL} from "./is-api-url.ts";

/**
 * Get the updated URL and headers to use for a request. This should be called
 * by khan-fetch.js and api-action-results-jquery.js.
 *
 * @param url the URL of the request
 * @param setHeaderCallback a function which takes
 * name and value arguments and sets the given header in the current request.
 * @returns an object that has the potentially-modified url and an array of
 * name/value pairs to set as headers by the user of this function.
 */
export const getUpdatedUrlAndHeaders = (
    url: string,
): {
    url: string;
    headers: Array<{
        name: string;
        value: string;
    }>;
} => {
    // We only process URLs that are going to an API endpoint
    if (!isAPIURL(url)) {
        return {
            url,
            headers: [],
        };
    }

    // Add the various params and headers
    const newUrl = addCacheParam(addConfigParams(url));
    const headers = getXsrfKeyHeaders(newUrl);

    return {
        url: isRelativeUrl(url) ? toRelativeUrl(newUrl) : newUrl,
        headers,
    };
};
